import React, { FC, useCallback, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { data } from './StakingBalancesTableLists'
import { TableSmall, IDataItem } from '../../../../../../components/Dashboard/TableSmall'
import { useRest } from '../../../../../../components/Context'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
  },
  sectionWrap: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(0, 4, 0, 4),
  },
}))

interface StakingBalancesSectionProps {
  title?: string
}

type tableProps = {
  balanceTreasury: IDataItem[]
  subTotal: string
  totalPortfolio: string
}

export const StakingBalances: FC<StakingBalancesSectionProps> = ({ title }) => {
  const classes = useStyles()
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })
  const { rxiosAuth } = useRest()
  // eslint-disable-next-line
  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<tableProps>({
    balanceTreasury: [],
    subTotal: '0',
    totalPortfolio: '0',
  })

  const loadData = useCallback(async () => {
    let cleanupFunction = false
    setLoading(true)

    rxiosAuth.get(data.request).subscribe(
      // eslint-disable-next-line
      (next: any) => {
        setValues(next)
        if (!cleanupFunction) setLoading(false)
      },
      (error) => {
        toast.error(error)
        setLoading(false)
      },
      () => {
        setLoading(false)
      },
    )
    cleanupFunction = true
    // eslint-disable-next-line
  }, [rxiosAuth])

  useEffect(() => {
    ;(async () => {
      await loadData()
    })()
    // eslint-disable-next-line
  }, [])

  return (
    <Grid item xs={12} className={classes.formWrap}>
      <FormProvider {...formMethods}>
        <Grid item xs={12} className={classes.container}>
          {title ? <Typography variant={'h6'}>{title}</Typography> : ' '}
        </Grid>

        <Grid item xs={12} className={classes.sectionWrap}>
          <TableSmall
            columns={data.columns}
            data={values.balanceTreasury}
            totalFields={[values.subTotal, values.totalPortfolio]}
            loading={loading}
          />
        </Grid>
      </FormProvider>
    </Grid>
  )
}
